module.exports = __webpack_public_path__ + "media/images/user-a41af107.png";